<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-microsoft-teams</v-icon>
            Teams Configuration
          </v-card-title>
          <v-card-text>
            <v-alert type="info" variant="tonal" class="mb-4">
              This page is used for Teams app configuration. It will be displayed when configuring
              the app in Teams.
            </v-alert>

            <v-form>
              <v-text-field
                v-model="config.title"
                label="App Title"
                variant="outlined"
                readonly
                class="mb-3"
              ></v-text-field>

              <v-textarea
                v-model="config.description"
                label="Description"
                variant="outlined"
                readonly
                rows="3"
                class="mb-3"
              ></v-textarea>

              <v-switch
                v-model="config.enableNotifications"
                label="Enable Notifications"
                color="primary"
                class="mb-3"
              ></v-switch>

              <v-switch
                v-model="config.autoLogin"
                label="Enable Auto Login"
                color="primary"
                class="mb-3"
                @change="updateAutoLoginSetting"
              ></v-switch>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveConfig"> Save Configuration </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { ref, onMounted } from 'vue'
import * as microsoftTeams from '@microsoft/teams-js'
import { useAuth } from '@/composables/useAuth'

export default {
  setup() {
    const { getTeamsAutoLogin, setTeamsAutoLogin } = useAuth()

    const config = ref({
      title: 'IS Global Applications and Tools',
      description:
        'Access IS Global applications, monitoring tools, and partner portals with integrated authentication.',
      enableNotifications: true,
      autoLogin: getTeamsAutoLogin(),
    })

    onMounted(async () => {
      try {
        await microsoftTeams.app.initialize()

        // Note: getConfig is not available in current Teams JS SDK
        // Configuration will be handled through the manifest and setConfig
      } catch (error) {
        console.error('Teams initialization error:', error)
      }
    })

    const updateAutoLoginSetting = (enabled: boolean) => {
      setTeamsAutoLogin(enabled)
    }

    const saveConfig = () => {
      // Update the auto-login setting
      setTeamsAutoLogin(config.value.autoLogin)

      microsoftTeams.pages.config.setConfig({
        contentUrl: window.location.origin + '/',
        entityId: 'is-global-tools',
        suggestedDisplayName: config.value.title,
        ...config.value,
      })

      microsoftTeams.pages.config.setValidityState(true)
    }

    return {
      config,
      saveConfig,
      updateAutoLoginSetting,
    }
  },
}
</script>

<style scoped>
/* Add any custom styles here */
</style>
